import styled from 'styled-components';

/**
 * Named solid tones used by identity pills in detail headers (job title,
 * rating). Kept here so every header pill in the app resolves the same colours.
 */
const SOLID_TONES = {
  teal: { bg: 'tagTealBg', fg: 'tagTealText' },
  gold: { bg: 'tagGoldBg', fg: 'tagGoldText' },
};

const resolveSolid = (props) => {
  const tone = SOLID_TONES[props.$tone] || SOLID_TONES.teal;
  return {
    bg: props.backgroundColor || props.theme?.[tone.bg],
    fg: props.color || props.theme?.[tone.fg],
  };
};

const StyledColoredTag = styled.div`
  border-radius: ${(props) =>
    props.$radius ??
    (props.$solid || props.$pill
      ? props.theme?.radiusPill ?? '999px'
      : props.theme?.radiusSm ?? '8px')};
  padding: ${(props) => props.$padding ?? (props.$solid ? '5px 14px' : '4px 10px')};
  font-weight: ${(props) => props.theme?.fontWeightSemibold ?? 600};
  font-size: ${(props) => props.$fontSize ?? '12px'};
  margin: 0 ${(props) => props.$marginX ?? '10px'};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.4;
  border: ${(props) => props.$border ?? ''};
  border-left: ${(props) =>
    props.$noStripe || props.$solid
      ? 'none'
      : `3px solid ${props.color || props.theme?.secondary || '#dc601e'}`};
  width: ${(props) => props.$width ?? 'auto'};
  height: ${(props) => props.$height ?? 'auto'};
  ${(props) => {
    if (props.$solid) {
      const { bg, fg } = resolveSolid(props);
      return `
        color: ${fg};
        background-color: ${bg};
      `;
    }
    const darkVariantText =
      props.theme?.dark && props.variant === 'green' ? '#8EE0B0' : undefined;
    const base =
      props.color ||
      darkVariantText ||
      (props.variant && props.theme?.[props.variant]) ||
      props.theme?.primary ||
      '#0d2349';
    const bg =
      props.backgroundColor ||
      (props.theme?.dark ? `${base}33` : `${base}1f`);
    return `
      color: ${base};
      background-color: ${bg};
    `;
  }}
`;

export default StyledColoredTag;
